<template>
  <KSelect :items="items" v-bind="$attrs" v-on="$listeners" ref="autocomplete" item-value="key" item-text="value"/>
</template>

<script>
import { publicApiEndpoints } from "@/api/endpoints/publicApi.js";
import KSelect from "@/components/crud/fields/KSelect.vue";

export default {
  name: 'PublicApiEndpointSelect',
  components: { KSelect },
  data: () => ({
    items: [],
  }),
  async created() {
    const response = await publicApiEndpoints(this.$route.params.clientId);
    this.items = response.data.data;
  },
};
</script>
